import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(() => ({
    messageContainer: {
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
}));
const MapMessage = (props) => {
    const {type, text} = props;
    const types = {
        error: 'error',
        info: 'textSecondary'
    };
    const classes = useStyles();
    return (
        <div className={classes.messageContainer}>
            <Typography color={types[type]}>{text}</Typography>
        </div>
    )
};

export default MapMessage

MapMessage.propTypes = {
    type: PropTypes.string,
    text: PropTypes.string
};